module.exports = __webpack_public_path__ + "static/media/icon_linux.f7eb4769.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/os/icon_linux.svg
// module id = 1342
// module chunks = 0